import { render, staticRenderFns } from "./BookingOverview.vue?vue&type=template&id=4d61cb5c&scoped=true&"
import script from "./BookingOverview.vue?vue&type=script&lang=js&"
export * from "./BookingOverview.vue?vue&type=script&lang=js&"
import style0 from "./BookingOverview.vue?vue&type=style&index=0&id=4d61cb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d61cb5c",
  null
  
)

export default component.exports